import { DEFAULT_ATTACHMENT_ID } from '../constants';
export function addAttachmentIdsReducer(state, action) {
    let newState = [...state];
    action.payload.attachments.forEach(attachment => {
        if (attachment.id !== DEFAULT_ATTACHMENT_ID) {
            newState = [...Array.from(new Set(newState.concat(attachment.id)))];
        }
    });
    return newState;
}
//# sourceMappingURL=addAttachmentIdsReducer.js.map